/**
 * The design system's action-icon set — a 1:1 mirror of the design source's
 * skoda-icons.jsx (window.SIco): filled paths on the 2..22 grid, 1.6 unit
 * weight, square terminals. If an icon is missing, add it here in this style
 * rather than dropping a one-off line icon into a page.
 *
 * Each icon is a list of paths; `evenodd` marks a path drawn with the
 * evenodd fill rule.
 */
export const ICON_PATHS = {
  trash: [
    {
      d: 'M6.42 19.84L6.06 6.46H3.72V4.92H8.3V3.88C8.3 2.76 9.18 1.84 10.48 1.84H13.52C14.82 1.84 15.7 2.76 15.7 3.88V4.92H20.28V6.46H17.94L17.58 19.84H6.42ZM10.06 4.06V4.92H13.94V4.06C13.94 3.66 13.6 3.32 13.2 3.32H10.8C10.4 3.32 10.06 3.66 10.06 4.06ZM7.96 18.3H16.04L16.28 6.46H7.72L7.96 18.3ZM9.58 17.22V7.54H11.08V17.22H9.58ZM12.92 17.22V7.54H14.42V17.22H12.92Z',
    },
  ],
  edit: [
    {
      d: 'M15.82 5.38C16.8 4.4 18.38 4.4 19.38 5.38C20.36 6.36 20.36 7.96 19.38 8.94L8.36 19.96L3.9 20.86L4.8 16.4L15.82 5.38ZM15.72 7.74L6.06 17.4L5.72 19.04L7.36 18.7L17.02 9.04L15.72 7.74Z',
    },
  ],
  eye: [
    {
      d: 'M12 5.54C16.48 5.54 19.84 9.06 21.76 11.96C19.84 14.86 16.48 18.38 12 18.38C7.52 18.38 4.16 14.86 2.24 11.96C4.16 9.06 7.52 5.54 12 5.54ZM12 7.24C8.58 7.24 6.34 9.62 4.34 11.96C6.34 14.3 8.58 16.68 12 16.68C15.42 16.68 17.66 14.3 19.66 11.96C17.66 9.62 15.42 7.24 12 7.24ZM12 14.48C10.62 14.48 9.48 13.34 9.48 11.96C9.48 10.58 10.62 9.44 12 9.44C13.38 9.44 14.52 10.58 14.52 11.96C14.52 13.34 13.38 14.48 12 14.48Z',
    },
  ],
  plus: [
    {
      d: 'M10.98 19.28V12.98H4.68V10.94H10.98V4.64H13.02V10.94H19.32V12.98H13.02V19.28H10.98Z',
    },
  ],
  save: [
    {
      d: 'M3.9 3.9H15.7L20.1 8.3V20.1H3.9V3.9ZM5.5 5.5V18.5H18.5V8.96L15.04 5.5H5.5Z',
      evenodd: true,
    },
    { d: 'M8.8 5.5H13.2V9.1H8.8V5.5Z' },
    { d: 'M7.4 11.9H16.6V18.5H7.4V11.9ZM9 13.5V16.9H15V13.5H9Z', evenodd: true },
  ],
  search: [
    {
      d: 'M11.2 3.6C15.14 3.6 18.4 6.86 18.4 10.8C18.4 14.74 15.14 18 11.2 18C7.26 18 4 14.74 4 10.8C4 6.86 7.26 3.6 11.2 3.6ZM11.2 5.2C8.14 5.2 5.6 7.74 5.6 10.8C5.6 13.86 8.14 16.4 11.2 16.4C14.26 16.4 16.8 13.86 16.8 10.8C16.8 7.74 14.26 5.2 11.2 5.2Z',
      evenodd: true,
    },
    { d: 'M16.06 17.19L17.19 16.06L20.8 19.67L19.67 20.8L16.06 17.19Z' },
  ],
  download: [
    { d: 'M11.2 3.8H12.8V14.2H11.2Z' },
    { d: 'M12 17.4L6.9 12.3L8.03 11.17L12 15.14L15.97 11.17L17.1 12.3L12 17.4Z' },
    { d: 'M4.4 19.2H19.6V20.8H4.4Z' },
  ],
  upload: [
    { d: 'M11.2 6.6H12.8V17H11.2Z' },
    { d: 'M12 3.4L17.1 8.5L15.97 9.63L12 5.66L8.03 9.63L6.9 8.5L12 3.4Z' },
    { d: 'M4.4 19.2H19.6V20.8H4.4Z' },
  ],
  doc: [
    {
      d: 'M5.4 3.2H14.2L18.6 7.6V20.8H5.4V3.2ZM7 4.8V19.2H17V8.26L13.54 4.8H7Z',
      evenodd: true,
    },
    { d: 'M8.6 11.6H15.4V13.2H8.6V11.6Z' },
    { d: 'M8.6 15H13.4V16.6H8.6V15Z' },
  ],
  car: [
    {
      d: 'M19.96 17.1C19.96 18.2 19.08 19.1 17.98 19.1C17.12 19.1 16.24 18.58 16.02 17.5H7.98C7.76 18.58 6.88 19.1 6.02 19.1C4.92 19.1 4.04 18.2 4.04 17.1V11.26L4.52 10.28H3.08V8.68H5.28L6.96 5.2H17.04L18.72 8.68H20.92V10.28H19.48L19.96 11.26V17.1ZM6.38 9.8H17.62L16.1 6.7H7.9L6.38 9.8ZM17.12 16.8C17.12 17.18 17.4 17.48 17.78 17.48C18.16 17.48 18.46 17.18 18.46 16.8V11.3H5.54V16.8C5.54 17.18 5.84 17.48 6.22 17.48C6.6 17.48 6.88 17.18 6.88 16.8V16H17.12V16.8ZM12 13.52C12.76 13.52 13.42 13.14 13.84 12.56H16.92V14.06H14.42C13.76 14.62 12.92 14.98 12 14.98C11.08 14.98 10.24 14.62 9.58 14.06H7.08V12.56H10.16C10.58 13.14 11.24 13.52 12 13.52Z',
    },
  ],
  tag: [
    {
      d: 'M12.6 3.4H20.6V11.4L11.6 20.4L3.6 12.4L12.6 3.4ZM13.26 5L5.86 12.4L11.6 18.14L19 10.74V5H13.26ZM16.2 6.6C17 6.6 17.6 7.2 17.6 8C17.6 8.8 17 9.4 16.2 9.4C15.4 9.4 14.8 8.8 14.8 8C14.8 7.2 15.4 6.6 16.2 6.6Z',
      evenodd: true,
    },
  ],
  info: [
    {
      d: 'M12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18ZM12 18.94C15.8 18.94 18.94 15.78 18.94 11.96C18.94 8.14 15.8 4.98 12 4.98C8.2 4.98 5.06 8.14 5.06 11.96C5.06 15.78 8.2 18.94 12 18.94ZM12 7.54C12.6 7.54 13.12 8.06 13.12 8.66C13.12 9.26 12.6 9.78 12 9.78C11.4 9.78 10.88 9.26 10.88 8.66C10.88 8.06 11.4 7.54 12 7.54ZM12.88 10.82V16.38H11.12V10.82H12.88Z',
    },
  ],
}
